import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PrivateRoute from "../PrivateRoute";
import CouponPage from "./pages/CouponPage";
import SpinWheel from "./pages/Game";
import UserDetails from "./pages/UserDetails";
const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/shoppers-stop">
          <SpinWheel />
        </Route>
        <PrivateRoute exact path="/shoppers-stop/userDetails">
          <UserDetails />
        </PrivateRoute>
        <PrivateRoute exact path="/shoppers-stop/couponDetails">
          <CouponPage />
        </PrivateRoute>
      </Switch>
    </Router>
  );
};

export default App;
